// ArcticFur's own GA4 events (31 Oct 2026; the full list is in docs/analytics.md).
//
// The store's GA4 property (G-R6RG20937T) already gets Shopify's standard events (page views, add to cart, checkout,
// purchase) through the Google & YouTube app. This adds the events the theme knows about and the app doesn't: Check
// Your Fit's steps, answers and paths, and how people move through the product page. They go to the same property
// through the page's Google tag (gtag.js, already on every page for Google Ads), configured here without a second
// page view, and only once the visitor has allowed analytics in Shopify's cookie banner (the Customer Privacy API).
// Until then they wait in a short queue, and they're dropped if analytics is never allowed.
//
// Anything on the page reports through window.afTrack(name, params); layout/theme.liquid defines a stand-in that
// queues calls made before this file has loaded. Add ?af_ga_debug=1 to a page address to see the events in GA4's
// DebugView.

const GA4_ID = 'G-R6RG20937T';
const debug = /[?&]af_ga_debug=1(&|$)/.test(location.search);
const queue = (window.afTrackQueue || []).map((args) => [args[0], args[1]]);
let ready = false;

function send(name, params) {
  try {
    window.gtag('event', name, { ...params, send_to: GA4_ID, ...(debug ? { debug_mode: true } : {}) });
  } catch {
    // Analytics never gets in the way of the page
  }
}

function start() {
  if (ready || typeof window.gtag !== 'function') return;
  ready = true;
  window.gtag('config', GA4_ID, { send_page_view: false, ...(debug ? { debug_mode: true } : {}) });
  queue.splice(0).forEach(([name, params]) => send(name, params));
}

window.afTrack = (name, params = {}) => {
  if (ready) send(name, params);
  else if (queue.length < 60) queue.push([name, params]);
};

// Consent: allowed already (or not needed where the visitor is), or given later in the banner
function checkConsent() {
  try {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) start();
  } catch {
    // No consent API: nothing is sent
  }
}

document.addEventListener('visitorConsentCollected', (event) => {
  if (event.detail?.analyticsAllowed) start();
});

if (window.Shopify?.customerPrivacy) {
  checkConsent();
} else if (typeof window.Shopify?.loadFeatures === 'function') {
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (!error) checkConsent();
  });
}
